module.exports = __webpack_public_path__ + "static/media/mental.nolimitcity.89a96f1b.jpeg";